var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5641 8.61719C14.1839 8.61719 13.9981 8.96342 13.8778 9.3473L13.5716 10.3251H12.5752C11.9343 10.3251 11.4182 10.8405 11.4182 11.4815V15.0415C11.4182 15.6824 11.9343 16.1985 12.5752 16.1985H19.2103C19.8512 16.1985 20.3673 15.6824 20.3673 15.0415V11.4815C20.3673 10.8405 19.8512 10.3251 19.2103 10.3251H18.2139L17.9077 9.3473C17.7875 8.9633 17.6016 8.61719 17.2215 8.61719H14.5641ZM15.8926 11.3248C16.9622 11.3249 17.8293 12.1919 17.8293 13.2615C17.8295 14.3313 16.9624 15.1987 15.8926 15.1988C14.8228 15.1987 13.9557 14.3313 13.9559 13.2615C13.9559 12.1919 14.823 11.3249 15.8926 11.3248Z",
    fill: "#C9C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon_photo.9f4482fd9f6cacd837741c9ded18b65a.svg";
export { ForwardRef as ReactComponent };